<template>
  <div class="formulir-detail-page">
    <div class="container-fluid mt-1">
      <div class="row">
        <div class="col-xl-12">
          <div class="card card-profile shadow">
            <div class="card-body">
              <h3 class="mb-4">Data Formulir Pendaftaran</h3>

              <!-- Student Information (Format like PDF) -->
              <div class="border-bottom pb-3 mb-3">
                <h6 class="text-uppercase text-primary ls-1 mb-3">I. SISWA</h6>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td width="30%" class="font-weight-bold">1. Nama</td>
                          <td width="2%" class="text-center">:</td>
                          <td class="font-weight-bold">{{ user.full_name }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">2. Jenis Kelamin</td>
                          <td class="text-center">:</td>
                          <td>{{ getGenderText(user.gender) }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">3. Tempat dan Tanggal Lahir</td>
                          <td class="text-center">:</td>
                          <td>{{ user.place_of_birth }}, {{ formatDate(user.date_of_birth) }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">4. Anak ke-</td>
                          <td class="text-center">:</td>
                          <td>{{ user.anak_ke }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">5. Jumlah Saudara</td>
                          <td class="text-center">:</td>
                          <td>
                            Kandung: {{ user.saudara_kandung > 0 ? user.saudara_kandung + ' orang' : '-' }}<br>
                            Tiri: {{ user.saudara_tiri > 0 ? user.saudara_tiri + ' orang' : '-' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">6. Alamat</td>
                          <td class="text-center">:</td>
                          <td>
                            <template v-if="alamatBaris.length">
                              <span v-for="(baris, i) in alamatBaris" :key="i">
                                {{ baris }}<br v-if="i < alamatBaris.length - 1">
                              </span>
                            </template>
                            <template v-else>-</template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td width="30%" class="font-weight-bold">Nomor Induk Siswa</td>
                          <td width="2%" class="text-center">:</td>
                          <td>{{ user.nik_siswa }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">NISN</td>
                          <td class="text-center">:</td>
                          <td>{{ user.nis_nas }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Parent Information (Format like PDF) -->
              <div class="border-bottom pb-3 mb-3">
                <h6 class="text-uppercase text-primary ls-1 mb-3">II. ORANG TUA/WALI</h6>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td width="3%" class="font-weight-bold">7.</td>
                          <td width="30%" class="font-weight-bold">Nama Orang Tua</td>
                          <td class="text-center">:</td>
                          <td>
                            Ayah: {{ user.parent_name || '-' }}<br>
                            Ibu: {{ user.ibu_nama || '-' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">8.</td>
                          <td class="font-weight-bold">Pekerjaan Orang Tua</td>
                          <td class="text-center">:</td>
                          <td>
                            Ayah: {{ user.ayah_pekerjaan || '-' }}<br>
                            Ibu: {{ user.ibu_pekerjaan || '-' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">9.</td>
                          <td class="font-weight-bold">Agama Orang Tua</td>
                          <td class="text-center">:</td>
                          <td>
                            Ayah: {{ getReligionText(user.agama) || '-' }}<br>
                            Ibu: {{ getReligionText(user.agama) || '-' }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">10.</td>
                          <td class="font-weight-bold">Alamat Orang Tua</td>
                          <td class="text-center">:</td>
                          <td>{{ user.ayah_alamat || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">11.</td>
                          <td class="font-weight-bold">Nama Wali</td>
                          <td class="text-center">:</td>
                          <td>{{ user.wali_nama || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">12.</td>
                          <td class="font-weight-bold">Pekerjaan Wali</td>
                          <td class="text-center">:</td>
                          <td>{{ user.wali_pekerjaan || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">13.</td>
                          <td class="font-weight-bold">Agama Wali</td>
                          <td class="text-center">:</td>
                          <td>{{ getReligionText(user.agama_wali) || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">14.</td>
                          <td class="font-weight-bold">Alamat Wali</td>
                          <td class="text-center">:</td>
                          <td>{{ user.wali_alamat || '-' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- School Information (Format like PDF) -->
              <div class="border-bottom pb-3 mb-3">
                <h6 class="text-uppercase text-primary ls-1 mb-3">III. MASUK PKBM INI</h6>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td width="3%" class="font-weight-bold">15.</td>
                          <td width="30%" class="font-weight-bold">Dari Sekolah/Madrasah</td>
                          <td class="text-center">:</td>
                          <td class="font-weight-bold">{{ user.sekolah_asal || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">16.</td>
                          <td class="font-weight-bold">Tanggal</td>
                          <td class="text-center">:</td>
                          <td>{{ formatDate(user.tanggal) }} diterima dikelas: {{ user.kelas }}, Program: {{ user.program }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">17.</td>
                          <td class="font-weight-bold">Surat Pindah Nomor</td>
                          <td class="text-center">:</td>
                          <td>{{ user.nomor_surat_pindah || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">18.</td>
                          <td class="font-weight-bold">No. Induk Sekolah Asal / NPSN</td>
                          <td class="text-center">:</td>
                          <td>{{ user.npsn || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">19.</td>
                          <td class="font-weight-bold">Ijazah Yang Dimiliki</td>
                          <td class="text-center">:</td>
                          <td>{{ user.ijazah_yang_dimiliki ? user.ijazah_yang_dimiliki.toUpperCase() : '-' }}<br>Tanggal Ijazah: {{ formatDate(user.tanggal_ijazah) }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">20.</td>
                          <td class="font-weight-bold">Diterbitkan pada tanggal</td>
                          <td class="text-center">:</td>
                          <td>{{ formatDate(user.ijazah_terbit) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Exit Information (Format like PDF) -->
              <div v-if="user.tanggal_left || user.alasan_left" class="border-bottom pb-3 mb-3">
                <h6 class="text-uppercase text-primary ls-1 mb-3">IV. MENINGGALKAN PKBM INI</h6>
                <div class="row mb-2">
                  <div class="col-md-12">
                    <table class="table table-borderless table-sm">
                      <tbody>
                        <tr>
                          <td width="3%" class="font-weight-bold">21.</td>
                          <td width="30%" class="font-weight-bold">Tanggal</td>
                          <td class="text-center">:</td>
                          <td>{{ formatDate(user.tanggal_left) }} Kelas / Program: {{ user.kelas_left || '-' }} / {{ user.program_left || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">22.</td>
                          <td class="font-weight-bold">Alasan</td>
                          <td class="text-center">:</td>
                          <td>{{ user.alasan_left || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">23.</td>
                          <td class="font-weight-bold">Ijazah dari PKBM No</td>
                          <td class="text-center">:</td>
                          <td>{{ user.no_ijazah_pkbm || '-' }}<br>Diterbitkan pada tanggal: {{ formatDate(user.tanggal_ijazah_pkbm) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Foto & Tanda Tangan -->
              <div class="d-flex justify-content-end mt-4">
                <div class="text-center" style="width: 120px;">
                  <div v-if="user.image_path" style="width: 100px; height: 120px; border: 1px solid #ccc; margin: 0 auto; overflow: hidden;">
                    <img :src="user.image_path" @error="onImgError($event)" style="width: 100%; height: 100%; object-fit: cover;" />
                  </div>
                  <div v-else style="width: 100px; height: 120px; border: 1px solid #999; margin: 0 auto; display: flex; align-items: center; justify-content: center;">
                    <span style="color: #999; font-size: 14px;">3x4</span>
                  </div>
                </div>
                <div class="text-center ml-4" style="width: 200px;">
                  <p class="mb-1">Ciamis, {{ formatTanggalIndonesia(user.tanggal) }}</p>
                  <div v-if="user.ttd" style="height: 60px; margin-bottom: 4px;">
                    <img :src="user.ttd" @error="onImgError($event)" style="max-height: 60px;" />
                  </div>
                  <div v-else style="height: 60px;"></div>
                  <p class="mb-0 font-weight-bold" style="text-decoration: underline;">{{ user.full_name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    userId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      isDetailMode: true
    };
  },
  computed: {
    ...mapGetters("FormulirPendaftaran", {
      user: "getUser"
    }),
    alamatBaris() {
      return this.splitAlamat(this.user && this.user.address);
    }
  },
  methods: {
    getGenderText(gender) {
      if (gender === "L") return "Laki-laki";
      if (gender === "P") return "Perempuan";
      return "-";
    },
    getReligionText(religion) {
      if (!religion || religion === "") return "-";
      const religions = {
        "ISLAM": "Islam",
        "KRISTEN": "Kristen",
        "KATOLIK": "Katolik",
        "HINDU": "Hindu",
        "BUDHA": "Budha",
        "KONGHUCU": "Khonghucu"
      };
      return religions[religion] || religion;
    },
    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (isNaN(d.getTime())) return date;
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    formatTanggalIndonesia(date) {
      const months = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember"
      ];
      const d = date ? new Date(date) : new Date();
      if (isNaN(d.getTime())) return date;
      return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    },
    splitAlamat(address) {
      const teks = (address || "").toString().trim().replace(/\s+/g, " ");
      if (!teks) return [];
      if (teks.length <= 30) return [teks];
      // pecah jadi 2 baris seimbang, utamakan pemisahan di koma terdekat tengah
      const tengah = Math.floor(teks.length / 2);
      let potong = -1;
      const komaIndeks = [];
      for (let i = 0; i < teks.length; i++) {
        if (teks[i] === ",") komaIndeks.push(i);
      }
      if (komaIndeks.length) {
        potong = komaIndeks.reduce((a, b) =>
          Math.abs(b - tengah) < Math.abs(a - tengah) ? b : a
        );
        const baris1 = teks.slice(0, potong + 1).trim();
        const baris2 = teks.slice(potong + 1).trim();
        if (baris1 && baris2) return [baris1, baris2];
      }
      const spasiKiri = teks.lastIndexOf(" ", tengah);
      const spasiKanan = teks.indexOf(" ", tengah);
      if (spasiKiri === -1 && spasiKanan === -1) return [teks];
      if (spasiKiri === -1) potong = spasiKanan;
      else if (spasiKanan === -1) potong = spasiKiri;
      else potong = tengah - spasiKiri <= spasiKanan - tengah ? spasiKiri : spasiKanan;
      return [teks.slice(0, potong).trim(), teks.slice(potong + 1).trim()];
    },
    onImgError(event) {
      event.target.style.display = 'none';
    }
  },
  watch: {
    '$route.params.userId': {
      handler(newUserId) {
        if (newUserId) {
          this.$store.dispatch("FormulirPendaftaran/getUserById", newUserId);
        }
      },
      immediate: true
    }
  },
  async created() {
    if (this.userId) {
      await this.$store.dispatch("FormulirPendaftaran/getUserById", this.userId);
    }
  }
};
</script>

<style lang="css" scoped>
</style>